export default __webpack_public_path__ + "static/media/31t.4b91c28b.jpg";